import React from "react"
import { IBaseProperty, IUIPropertyDefinition, PropertyPath } from "../../../common/common"
import { ISearchTab, defaultTab } from "./SearchWidget"
import { BackgroundPositionEditor, CustomColorPicker, Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle, escapeUnit } from "../../../common/ui-props/common"
import { Button, Checkbox, Input, Label, Select, ToggleFilter } from "uxp/components"
import { generateFullUUID, hasValue } from "../../../../util"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { WidgetDesignerPillInput } from "../../../common/pill-input/PillInput"
import jp from 'jsonpath'
import { DataSourcePropertyEditor } from "../../../common/ui-props/DataSourceProperty"
import ActionEditorLink from "../../../common/action-editor/ActionEditor"
import IconEditor from "../../../common/icon-selector/IconEditor"
import { ImagePicker } from "lucy/common-components"
import { LabelProperties } from "../../../common/ui-fields/item-card-field/ItemCardProperty"
import { MultipleItemsProperty } from "../../../common/ui-fields/item-card-field/MultipleItemsProperty"
import { ICFButton } from "../../../common/ui-fields/item-card-field/ItemCard"

type ISearchTabProperty = ISearchTab[]


export function SearchTabsProperty(defaultProps: ISearchTabProperty, datasourcesPath: PropertyPath, title?: string): IUIPropertyDefinition<ISearchTabProperty> {
    return {
        defaults: defaultProps,
        render: (props, uxpContext, contextData, containerId, customProps) => {

            const datasources = customProps?.datasources || []
            const _props = props.uiProps
            const _selectedTab = contextData.selectedTab
            const _selectedIndex = _props.findIndex(p => p.id === _selectedTab?.id)

            function updateTab(id: string, title: string) {
                let _cols = (_props || [])
                const updated = _cols.map(c => {
                    if (c.id == id) c.title = title
                    return c
                })
                props.onChange(updated)
            }

            function addTab() {
                let _cols = (_props || [])
                _cols.push({ ...structuredClone(defaultTab), id: generateFullUUID(), title: `tab ${_cols.length + 1}` })
                props.onChange(_cols)
            }

            function removeTab(id: string) {
                let _cols = (_props || [])
                let updated = _cols.filter(c => c.id !== id)

                props.onChange(updated)
            }

            return <>
                <PropertyContainer>
                    <PropertyContainerTitle>{title || 'Search Tabs'}</PropertyContainerTitle>

                    <PropertyGroup>
                        <PropertyGroupTitle>Tabs</PropertyGroupTitle>
                        <Property>
                            <div className="tab-layout-tab-list">
                                {
                                    _props?.map((t, i) => {

                                        return <div className="tab-layout-column">
                                            <Label>
                                                Tab {i + 1}
                                            </Label>
                                            <Input
                                                value={t.title || ''}
                                                onChange={s => {
                                                    updateTab(t.id, s)
                                                }}
                                                placeholder="Auto"
                                            />
                                            {_props?.length > 1 &&
                                                <div className="tab-layout-column-remover" onClick={() => {
                                                    removeTab(t.id)
                                                }}  >
                                                    <FontAwesomeIcon icon={['fas', 'times']} />
                                                </div>
                                            }
                                        </div>
                                    })
                                }

                                <Button
                                    className="new-option"
                                    title="Add Column"
                                    icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                                    iconPosition="right"
                                    onClick={() => addTab()}
                                />
                            </div>
                        </Property>
                    </PropertyGroup>
                </PropertyContainer>

                {!!_selectedTab?.id && hasValue(_selectedIndex, true) &&
                    <PropertyContainer>
                        <PropertyContainerTitle>Selected Tab : {_selectedTab.title} </PropertyContainerTitle>
                        <PropertyGroup>

                            <Property>
                                <DataSourcePropertyEditor
                                    binding={_props?.[_selectedIndex]?.binding}
                                    context={props.uxpContext}
                                    className={'wd-chart-source'}
                                    onChange={(binding) => {
                                        jp.apply(_props, `$[${_selectedIndex}].binding`, () => (binding))
                                        props.onChange(_props)
                                    }}
                                    onChangeAny={(p, v) => {

                                        props.onChangeAny(datasourcesPath, v);
                                    }}
                                    sources={datasources}
                                    target={'dictionary-array'}
                                    title='Data Source'
                                    contextData={contextData}
                                    designer={props.designer}
                                />
                            </Property>

                            <Property styles={{ padding: '0 10px', margin: 0 }}>
                                <Checkbox
                                    checked={_props?.[_selectedIndex]?.hasMapView}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].hasMapView`, () => (s))
                                        props.onChange(_props)
                                    }}
                                    label="Enable map view"
                                />
                            </Property>

                            <Property styles={{ padding: '0 10px', margin: 0 }}>
                                <Checkbox
                                    checked={_props?.[_selectedIndex]?.hasFilters}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].hasFilters`, () => (s))
                                        props.onChange(_props)
                                    }}
                                    label="Enable filters"
                                />
                            </Property>
                        </PropertyGroup>

                        <PropertyGroup>
                            <PropertyGroupTitle>Image</PropertyGroupTitle>

                            <Property>
                                <PropertyTitle>Image Type</PropertyTitle>
                                <ToggleFilter
                                    value={_props?.[_selectedIndex]?.searchResultTile?.imageType}
                                    className={'cf-image-toggle'}
                                    options={[
                                        { label: 'Image', value: 'image' },
                                        { label: 'Icon', value: 'icon' }
                                    ]}
                                    onChange={(v) => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.imageType`, () => (v))
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>

                            <Property>
                                <Checkbox
                                    checked={_props[_selectedIndex]?.searchResultTile?.imageBorderType == 'circular'}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.imageBorderType`, () => (s ? 'circular' : 'square'))
                                        props.onChange(_props)
                                    }}
                                    label={`Circular ${_props[_selectedIndex]?.searchResultTile?.imageType == 'icon' ? 'Icon' : 'Image'}`}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Image Size</PropertyTitle>
                                <Input
                                    type='number'
                                    value={(_props[_selectedIndex]?.searchResultTile?._imageSize?.toString())}
                                    onChange={(s) => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile._imageSize`, () => (s))
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Image Background Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData} color={_props[_selectedIndex]?.searchResultTile?.imageBackgroundColor}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.imageBackgroundColor`, () => (s))
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>


                            {
                                (_props[_selectedIndex]?.searchResultTile?.imageType == 'icon') && <>
                                    <Property>
                                        <PropertyTitle>Icon</PropertyTitle>
                                        <IconEditor value={_props[_selectedIndex]?.searchResultTile?.imageIcon}
                                            onChange={s => {
                                                jp.apply(_props, `$[${_selectedIndex}].searchResultTile.imageIcon`, () => (s))
                                                props.onChange(_props)
                                            }}

                                        />
                                    </Property>
                                    <Property>
                                        <PropertyTitle>Icon Color</PropertyTitle>
                                        <CustomColorPicker contextData={props.contextData} color={_props[_selectedIndex]?.searchResultTile?.imageIconColor}
                                            onChange={s => {
                                                jp.apply(_props, `$[${_selectedIndex}].searchResultTile.imageIconColor`, () => (s))
                                                props.onChange(_props)
                                            }}

                                        />
                                    </Property>
                                </>
                            }
                            {
                                (_props[_selectedIndex]?.searchResultTile?.imageType == 'image') && <>
                                    {/* <Property>
                                        <PropertyTitle>Image</PropertyTitle>
                                        <ImagePicker
                                            uxpContext={props.uxpContext}
                                            imageUrl={_props[_selectedIndex]?.searchResultTile?.image || ''}
                                            onChange={s => {
                                                jp.apply(_props, `$[${_selectedIndex}].searchResultTile.image`, () => (s))
                                                props.onChange(_props)
                                            }}
                                        />
                                    </Property> */}
                                    <Property>
                                        <PropertyTitle>Image Field</PropertyTitle>
                                        <WidgetDesignerPillInput
                                            value={_props?.[_selectedIndex]?.searchResultTile?.imageField || ''}
                                            onChange={s => {
                                                jp.apply(_props, `$[${_selectedIndex}].searchResultTile.imageField`, () => (s))
                                                props.onChange(_props)
                                            }}
                                            className={'widget-designer-pill-input'}
                                            placeholder={"Profile image"}
                                            contextData={contextData}
                                        />
                                    </Property>

                                </>
                            }



                            {/* <Property>
                                <PropertyTitle>Image Position</PropertyTitle>
                                <BackgroundPositionEditor
                                    position={_props?.[_selectedIndex]?.searchResultTile?.imagePosition || ''}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.imagePosition`, () => (s))
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Image Size</PropertyTitle>
                                <Select
                                    selected={_props?.[_selectedIndex]?.searchResultTile?.imageSize || 'cover'}
                                    options={[
                                        { label: 'Original Size', value: 'auto' },
                                        { label: 'Fill Area', value: 'cover' },
                                        { label: 'Fit Into Area', value: 'contain' }
                                    ]}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.imageSize`, () => (s))
                                        props.onChange(_props)
                                    }}
                                    className="widget-designer-input"
                                />
                            </Property> */}

                        </PropertyGroup>

                        <PropertyGroup>
                            <PropertyGroupTitle>Title</PropertyGroupTitle>
                            <Property>
                                <PropertyTitle>Title Field</PropertyTitle>
                                <WidgetDesignerPillInput
                                    value={_props[_selectedIndex]?.searchResultTile?.titleField}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.titleField`, () => (s))
                                        props.onChange(_props)
                                    }}
                                    className={'widget-designer-pill-input'}
                                    placeholder={"Title "}
                                    contextData={contextData}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Title Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props?.[_selectedIndex]?.searchResultTile?.titleColor}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.titleColor`, () => (s))
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Title Size</PropertyTitle>
                                <Input
                                    type='number'
                                    value={escapeUnit(_props?.[_selectedIndex]?.searchResultTile?.titleSize || '', 'px')}
                                    onChange={s => {
                                        let num = Number(s) || 0
                                        if (num < 8) s = '8'
                                        else if (num > 200) s = '200'
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.titleSize`, () => (s + 'px'))
                                        props.onChange(_props)
                                    }}
                                    className="widget-designer-input"
                                    inputAttr={{
                                        max: '200',
                                        min: '8'
                                    }}
                                />
                            </Property>
                        </PropertyGroup>
                        <PropertyGroup>
                            <PropertyGroupTitle>Sub title</PropertyGroupTitle>
                            <Property>
                                <PropertyTitle>Sub Title Field</PropertyTitle>
                                <WidgetDesignerPillInput
                                    value={_props[_selectedIndex]?.searchResultTile?.subTitleField || ''}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.subTitleField`, () => (s))
                                        props.onChange(_props)
                                    }}
                                    className={'widget-designer-pill-input'}
                                    placeholder={"Sub Title"}
                                    contextData={contextData}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Sub Title Color</PropertyTitle>
                                <CustomColorPicker contextData={props.contextData}
                                    color={_props?.[_selectedIndex]?.searchResultTile?.subTitleColor}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.subTitleColor`, () => (s))
                                        props.onChange(_props)
                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Sub Title Size</PropertyTitle>
                                <Input
                                    type='number'
                                    value={escapeUnit(_props?.[_selectedIndex]?.searchResultTile?.subTitleSize || '', 'px')}
                                    onChange={s => {
                                        let num = Number(s) || 0
                                        if (num < 8) s = '8'
                                        else if (num > 200) s = '200'
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.subTitleSize`, () => (s + 'px'))
                                        props.onChange(_props)
                                    }}
                                    className="widget-designer-input"
                                    inputAttr={{
                                        max: '200',
                                        min: '8'
                                    }}
                                />
                            </Property>
                        </PropertyGroup>

                        {_selectedTab?.hasMapView &&
                            <PropertyGroup>
                                <PropertyGroupTitle>Map view</PropertyGroupTitle>
                                <Property>
                                    <PropertyTitle>Latitude Field</PropertyTitle>
                                    <WidgetDesignerPillInput
                                        value={_props[_selectedIndex]?.searchResultTile?.latitudeField || ''}
                                        onChange={s => {
                                            jp.apply(_props, `$[${_selectedIndex}].searchResultTile.latitudeField`, () => (s))
                                            props.onChange(_props)
                                        }}
                                        className={'widget-designer-pill-input'}
                                        placeholder={"Latitude"}
                                        contextData={contextData}
                                    />
                                </Property>

                                <Property>
                                    <PropertyTitle>Longitude Field</PropertyTitle>
                                    <WidgetDesignerPillInput
                                        value={_props[_selectedIndex]?.searchResultTile?.longitudeField}
                                        onChange={s => {
                                            jp.apply(_props, `$[${_selectedIndex}].searchResultTile.longitudeField`, () => (s))
                                            props.onChange(_props)
                                        }}
                                        className={'widget-designer-pill-input'}
                                        placeholder={"Longitude"}
                                        contextData={contextData}
                                    />
                                </Property>

                            </PropertyGroup>
                        }

                        <PropertyGroup>
                            <Property>
                                <PropertyTitle>On click Item</PropertyTitle>
                                <ActionEditorLink
                                    uiProps={props.parentUIProps}
                                    designer={props.designer}
                                    uxpContext={uxpContext}
                                    action={_props[_selectedIndex]?.searchResultTile?.onClick || { type: 'open-url' }}
                                    onChange={s => {
                                        jp.apply(_props, `$[${_selectedIndex}].searchResultTile.onClick`, () => (s))
                                        props.onChange(_props)
                                    }}
                                    contextData={contextData}
                                />
                            </Property>
                        </PropertyGroup>

                        <PropertyGroup>
                            <PropertyGroupTitle>Top Labels</PropertyGroupTitle>
                            <Property>
                                {
                                    LabelProperties(_props[_selectedIndex]?.searchResultTile?.topLabels || [],

                                        (items) => {
                                            jp.apply(_props, `$[${_selectedIndex}].searchResultTile.topLabels`, () => (items))
                                            props.onChange(_props)
                                        },
                                        contextData
                                    )
                                }
                            </Property>
                        </PropertyGroup>

                        <PropertyGroup>
                            <PropertyGroupTitle>Bottom Labels</PropertyGroupTitle>
                            <Property>
                                {
                                    LabelProperties(_props[_selectedIndex]?.searchResultTile?.bottomLabels || [],
                                        (items) => {
                                            jp.apply(_props, `$[${_selectedIndex}].searchResultTile.bottomLabels`, () => (items))
                                            props.onChange(_props)
                                        },
                                        contextData
                                    )
                                }
                            </Property>
                        </PropertyGroup>

                        <PropertyGroup>
                            <PropertyGroupTitle>Buttons</PropertyGroupTitle>
                            <MultipleItemsProperty<ICFButton>
                                items={_props[_selectedIndex]?.searchResultTile?.buttons || []}
                                newItem={() => ({
                                    icon: 'play',
                                    color: "#424242",
                                    backgroundColor: "#EEE",
                                    onClick: { type: "open-url", redirectUrl: { url: 'about:blank' } }
                                })}
                                onChange={(items) => {
                                    jp.apply(_props, `$[${_selectedIndex}].searchResultTile.buttons`, () => (items))
                                    props.onChange(_props)
                                }}
                                render={(item, onChange) => {
                                    return <div className='cf-label-item'>


                                        <div className='cf-m-f'>
                                            <label>Icon</label>
                                            <IconEditor onChange={(s) => onChange({ ...item, icon: s })} value={item.icon} />
                                        </div>
                                        <div className='cf-m-f'>
                                            <label>Icon Color</label>
                                            <CustomColorPicker contextData={props.contextData} onChange={(s) => onChange({ ...item, color: s })} color={item.color} />
                                        </div>
                                        <div className='cf-m-f'>
                                            <label>Icon Background</label>
                                            <CustomColorPicker contextData={props.contextData} onChange={(s) => onChange({ ...item, backgroundColor: s })} color={item.backgroundColor} />
                                        </div>
                                        <div className='cf-m-f'>
                                            <ActionEditorLink
                                                uiProps={props.parentUIProps}
                                                uxpContext={props?.uxpContext}
                                                action={item.onClick}
                                                onChange={(s) => onChange(Object.assign({}, item, { onClick: s }))}
                                                contextData={contextData}
                                            />
                                        </div>

                                    </div>

                                }}
                                title=""

                            />
                        </PropertyGroup>
                        <PropertyGroup>
                            <PropertyGroupTitle>Sort Options</PropertyGroupTitle>

                            <Property>

                                {_props[_selectedIndex]?.sortOptions?.length &&
                                    <div className="wd-ui-property-group-title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        Sort Options
                                    </div>
                                }
                                {!_props[_selectedIndex]?.sortOptions?.length && <Label>No options were added</Label>}
                                <div>

                                    {_props[_selectedIndex]?.sortOptions?.map((s, i) => {

                                        return <div className="ui-field-config-item-row">
                                            <div className="column" style={{ width: '40%' }}>
                                                <Input
                                                    placeholder="Label"
                                                    value={s?.label || ''}
                                                    onChange={s => {


                                                        jp.apply(_props[_selectedIndex], `$.sortOptions[${i}].label`, () => (s))
                                                        props.onChange(_props)
                                                    }}
                                                />
                                            </div>

                                            <div className="column" style={{ width: '40%' }}>

                                                <Input
                                                    placeholder="Field"
                                                    value={s?.field || ''}
                                                    onChange={s => {
                                                        jp.apply(_props[_selectedIndex], `$.sortOptions[${i}].field`, () => (s))
                                                        props.onChange(_props)
                                                    }}
                                                />
                                            </div>

                                            <div className="column" style={{ width: '10%' }}>

                                                <FontAwesomeIcon icon={s?.descending ? 'arrow-down' : 'arrow-up'}
                                                    onClick={() => {
                                                        jp.apply(_props[_selectedIndex], `$.sortOptions[${i}].descending`, () => (!s?.descending))
                                                        props.onChange(_props)

                                                    }}

                                                />
                                            </div>


                                            <div className="column  action-column"
                                                onClick={() => {
                                                    let options = _props[_selectedIndex]?.sortOptions || []
                                                    options.splice(i, 1)

                                                    jp.apply(_props[_selectedIndex], `$.sortOptions`, () => (options))
                                                    props.onChange(_props)
                                                }}
                                            >
                                                <FontAwesomeIcon icon={['fas', 'trash']} className='delete' />
                                            </div>
                                        </div>
                                    })}
                                    <Button
                                        className="new-option"
                                        title="Add New Option"
                                        icon={"/Resources/Lucy/lucy-dashboard/assets/images/plus-rounded.svg"}
                                        iconPosition="right"
                                        onClick={() => {
                                            let options = _props[_selectedIndex]?.sortOptions || []
                                            options.push({ label: '', field: '', descending: true })
                                            // jp.apply(_props[_selectedIndex], `$.sortOptions`, () => (options))
                                            let newProps = [..._props];
                                            newProps[_selectedIndex] = { ...newProps[_selectedIndex], sortOptions: options };
                                            props.onChange(newProps);
                                        }}
                                    />



                                </div>

                            </Property>
                        </PropertyGroup>

                        <PropertyGroup>
                            <PropertyGroupTitle>No results</PropertyGroupTitle>

                            <Property>
                                <PropertyTitle>Message</PropertyTitle>
                                <Input
                                    value={_props?.[_selectedIndex]?.noResultMessage || ''}
                                    onChange={(v) => {

                                        const updated = _props.map((p, i) => {
                                            if (i == _selectedIndex) {
                                                p.noResultMessage = v
                                            }
                                            return p
                                        })
                                        props.onChange(updated)
                                    }}
                                />
                            </Property>

                            <Property>
                                <PropertyTitle>Image</PropertyTitle>
                                <ImagePicker
                                    uxpContext={uxpContext}
                                    imageUrl={_props?.[_selectedIndex]?.noResultImage || ''}
                                    onChange={(v) => {
                                        const updated = _props.map((p, i) => {
                                            if (i == _selectedIndex) {
                                                p.noResultImage = v
                                            }
                                            return p
                                        })
                                        props.onChange(updated)
                                    }}
                                />
                            </Property>

                        </PropertyGroup>

                    </PropertyContainer >

                }
            </>
        }
    }
}